
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order/city/[city]",
      function () {
        return require("private-next-pages/order/city/[city].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order/city/[city]"])
      });
    }
  